<template>
  <div class="grid-container mb-6" id="copy-to-doctors-grid">
    <v-row>
      <v-col cols="2">
        <span class="text-title">Provider number</span>
        <v-text-field
          v-model="providerNum"
          :id="'cc' + currCount + '.providerNum'"
          outlined
          :maxlength="limitProviderNum"
          hide-details="auto"
        ></v-text-field>
      </v-col>

      <v-col cols="5">
        <span class="text-title">Given name*</span>
        <v-text-field
          v-model="firstName"
          :id="'cc' + currCount + '.firstName'"
          :rules="ruleNotNull"
          outlined
          :maxlength="limitGivenName"
          hide-details="auto"
        ></v-text-field
      ></v-col>
      <v-col cols="5">
        <span class="text-title">Surname*</span>
        <v-text-field
          v-model="lastName"
          :id="'cc' + currCount + '.lastName'"
          :rules="ruleNotNull"
          outlined
          style="grid-area: lastName"
          :maxlength="limitSurname"
          hide-details="auto"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="custom-col">
        <span class="text-title">Email</span>
        <v-text-field
          v-model="emailAddress"
          :id="'cc' + currCount + '.emailAddress'"
          class="mb-4"
          outlined
          :maxlength="limitEmail"
          :rules="ruleValidOptionalEmail"
          hide-details="auto"
        ></v-text-field>
      </v-col>

      <v-col class="custom-col">
        <span class="text-title">Clinic name*</span>
        <v-text-field
          v-model="clinicName"
          :id="'cc' + currCount + '.clinicName'"
          :rules="ruleNotNull"
          outlined
          :maxlength="limitClinicName"
          hide-details="auto"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="custom-col">
        <v-btn
          @click.stop="dialog = true"
          class="primary-btn btn-padding-medium"
          >Remove CC doctor</v-btn
        >
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline"
          >Are you sure you want to remove this CC?</v-card-title
        >
        <v-card-actions>
          <v-spacer> </v-spacer>
          <v-btn
            class="secondary-btn btn-padding-medium"
            text
            @click="dialog = false"
          >
            No
          </v-btn>

          <v-btn
            class="primary-btn btn-padding-medium"
            text
            @click="
              dialog = false;
              $emit('removeCopyTo', currIndex);
            "
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FormRulesMixin from "../mixins/FormRulesMixin";
import DropDownMixin from "../mixins/DropDownMixin";
export default {
  name: "",

  props: { currIndex: String, currCount: String, doctor: Object },

  mixins: [FormRulesMixin, DropDownMixin],

  data: function() {
    let newData = {
      dialog: false,
      providerNum: this.doctor.providerNum || "",
      firstName: this.doctor.firstName || "",
      lastName: this.doctor.lastName || "",
      clinicName: this.doctor.clinicName || "",
      emailAddress: this.doctor.emailAddress || "",
    };
    return newData;
  },

  methods: {
    transferData: function() {
      /** We speculate that some combinations of UI interactions in Copy to doctors section
       * causes the input fields value to be `undefined` which in turn causes schema errors
       * when passing otrs order data to labware.
       * Therefore, || "" is used for every property. If any input value becomes `undefined`,
       * it takes the value of an empty string instead.
       */
      return {
        providerNum: this.providerNum || "",
        firstName: this.firstName || "",
        lastName: this.lastName || "",
        clinicName: this.clinicName || "",
        emailAddress: this.emailAddress || "",
      };
    },
  },
};
</script>
